// WB-INK-001 — per-user Ink-to-Text setting (server-stored; OFF by default; one-time privacy notice).
import { useCallback, useEffect, useState } from 'react';
import { toast } from 'sonner';
import { apiRequest } from '../../utils/adminApi';

export const useInkSettings = () => {
  const [settings, setSettings] = useState({ enabled: false, auto_convert: false, notice_acknowledged: false, loaded: false });

  useEffect(() => {
    let alive = true;
    apiRequest('/training/whiteboard/ink-settings')
      .then((s) => alive && setSettings({ ...s, loaded: true }))
      .catch(() => alive && setSettings((s) => ({ ...s, loaded: true })));
    return () => { alive = false; };
  }, []);

  const save = useCallback(async (enabled, autoConvert = false) => {
    try {
      const s = await apiRequest('/training/whiteboard/ink-settings', {
        method: 'PUT',
        body: JSON.stringify({ enabled, auto_convert: enabled && autoConvert, notice_acknowledged: true }),
      });
      setSettings({ ...s, loaded: true });
      const msg = !enabled ? 'Ink-to-Text turned off'
        : s.auto_convert ? 'Auto Convert is on — clear handwriting becomes text automatically (Undo restores it)'
          : 'Ink-to-Text is on — pause after writing to get a suggestion';
      toast.success(msg, { id: 'wb-ink-toggle' });
    } catch (e) {
      toast.error(e.message || 'Could not update Ink-to-Text setting');
    }
  }, []);

  return { ...settings, save };
};
